import React from "react";
import { string } from "prop-types";

const AuthField = ({
  required,
  header,
  error,
  name,
  value,
  update,
  placeholder,
  description,
  noIcon,
  type,
  minLength,
  maxLength,
  pattern,
  title,
  classNameField,
  classNameLabel,
  classNameText,
  classNameInput,
  classNameMessage,
  storeUrl,
  disabled,
}) => {
  // Conditional styles for disabled state
  const disabledStyles = disabled
    ? {
        backgroundColor: "#f0f0f0", 
        color: "#999",
        cursor: "not-allowed",
      }
    : {};

  return (
    <label className={classNameField} htmlFor={name}>
      <div
        className={`${classNameLabel} auth-label${required ? " required" : ""}`}
      >
        <span className={classNameText}>{header}</span>
      </div>
      {storeUrl && (
        <span style={{ marginTop: "14px", marginRight: "10px" }}>
          https://{" "}
        </span>
      )}
      <input
        className={`${classNameInput} auth-field${error ? " error" : ""}${
          noIcon ? " no-icon" : ""
        }`}
        placeholder={placeholder}
        autoComplete="no"
        type={type || name}
        name={name}
        id={name}
        value={value}
        onChange={update}
        minLength={minLength}
        maxLength={maxLength}
        pattern={pattern}
        title={title}
        disabled={disabled}
        style={disabledStyles}
      />
      {/* {storeUrl && (
        <span style={{ margin: "14px 35px 0px 10px" }}>/myshopify.com</span>
      )} */}
      {noIcon ? null : <i className={`icon-${type || name}`} />}
      <span className={`input-description`}>{description}</span>
      <div
        className={`${classNameMessage} validation-error`}
        style={{ marginTop: "57px" }}
      >
        {error}
      </div>
    </label>
  );
};

AuthField.defaultProps = {
  classNameField: "",
  classNameText: "",
  classNameLabel: "",
  classNameInput: "",
  classNameMessage: "",
};

AuthField.propTypes = {
  classNameField: string,
  classNameText: string,
  classNameLabel: string,
  classNameInput: string,
  classNameMessage: string,
};

export default AuthField;
